module.exports = __webpack_public_path__ + "media/images/icon/man-83fccf56e8e74d60c30dd1904732280e.svg";